import * as helper from './../../../../../VX/View/Assets/Js/helper';
import AlertBox from './AlertBox';

export default class Section6 {
	constructor() {
		this.figur = helper.$('#figur');
		this.groesse = helper.$('#groesse');
		this.haare = helper.$('#haare');
		this.augen = helper.$('#augen');
		this.sexuality = helper.$('#sexuality');
		this.intimatehair = helper.$('#intimatehair');
		this.penissize = helper.$('#penissize');
		this.alertBox = new AlertBox(helper.$('#section6'));
	}

	get values() {
		return {
			'physique' : this.figur.value,
			'height': this.groesse.value,
			'hair': this.haare.value,
			'eyes': this.augen.value,
			'sexuality': this.sexuality.value,
			'intimatehair': this.intimatehair.value,
			'penissize': this.penissize.value,
		};
	}

	isValid() {
		if (this.figur.value === '') {
			helper.addClass(this.figur, 'alertborder');
			this.alertBox.show('Bitte wähle deine Figur');
			return false;
		}
		helper.removeClass(this.figur, 'alertborder');

		if (parseInt(this.groesse.value) < 40) {
			helper.addClass(this.groesse, 'alertborder');
			this.alertBox.show('Bitte gib deine Größe an');
			return false;
		}
		helper.removeClass(this.groesse, 'alertborder');

		if (this.haare.value === '') {
			helper.addClass(this.haare, 'alertborder');
			this.alertBox.show('Bitte wähle deine Haarfarbe');
			return false;
		}
		helper.removeClass(this.haare, 'alertborder');

		if (this.augen.value === '') {
			helper.addClass(this.augen, 'alertborder');
			this.alertBox.show('Bitte wähle deine Augenfarbe');
			return false;
		}
		helper.removeClass(this.augen, 'alertborder');

		if (this.sexuality.value === '') {
			helper.addClass(this.sexuality, 'alertborder');
			this.alertBox.show('Bitte sage deine sexuelle Ausrichtugn');
			return false;
		}
		helper.removeClass(this.sexuality, 'alertborder');

		if (this.intimatehair.value === '') {
			helper.addClass(this.intimatehair, 'alertborder');
			this.alertBox.show('Bitte sage uns wie deine Intimfrisur ist');
			return false;
		}
		helper.removeClass(this.intimatehair, 'alertborder');

		if (this.penissize.value === '') {
			helper.addClass(this.penissize, 'alertborder');
			this.alertBox.show('Bitte teile uns deine Penisgrösse mit');
			return false;
		}
		helper.removeClass(this.penissize, 'alertborder');

		this.alertBox.hide();
		return true;
	}
}
